import { useEffect, useState } from "react";
import { fetchAPI } from "../../Helpers/utils";

export type BlogCategoriesModel = {
  title: string
}

export default function BlogCategories({ title }: BlogCategoriesModel) {
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    async function getData() {
      const data = await fetchAPI<any>(`/api/blog/categories`);
      if (data.result) {
        setCategories(data.result);
      }
    }

    getData();
  }, []);

  return (
    <div className="categories">
			<div className="title"><h6>{title}</h6></div>
			<ul className="list">
        { categories.length > 0 && categories.map((item, index) => {
            return (
              <li key={`category-${index}`}>
                <a href="#">{item}</a>
            </li>
            )
          })
        }
			</ul>
		</div>
  )
}